module.exports = __webpack_public_path__ + "294024d11b4ace06bd9bdf9ba5be2988.svg";